import { useMemo } from "react";

import { useRecoilState } from "recoil";

import { AccountAdapter } from "adapters/account";
import { userAtom } from "atomsStorage/user";
import { IAccount } from "types/account";

export const useUser = () => {
  const [data, setData] = useRecoilState(userAtom);

  const setUserData = (newData: IAccount) => setData(AccountAdapter.toModel(newData));

  return {
    setUserData,
    data,
  };
};
